import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from './user-profile.service';
import { NgIf, NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        RouterLink,
        NgStyle,
    ],
})
export class UserProfileComponent implements OnInit {

  public screenWidth: number;
  public user: any;
  private subscriber: Subscription;
  userEmail: string;
  public userType: boolean;
  APP_SETTINGS;

  constructor(
    private utilityService: UtilityService,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private spinnerService: SpinnerService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
    this.spinnerService.show('bmwSpinner');
    this.APP_SETTINGS = APP_SETTINGS;
    this.userType = this.APP_SETTINGS['isExternal'];

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
      this.user = userData;
      this.spinnerService.hide('bmwSpinner');
    }, error => {
      this.spinnerService.hide('bmwSpinner');
    });
    // this.subscriber = this.userProfileService.getUsersInfoByEmail(this.userEmail).subscribe(data => {
    //   this.user = data;
    // });
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }


}
